import React, { createContext, useContext, useState, useEffect } from "react";
import authService from "./services/authService";
import localStorageService from "./services/LocalStorageService";

export const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    return localStorageService.getUser();
  });
  const [loading, setLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(() => {
    return localStorageService.getSelectedRole() || null;
  });
  const [roles, setRoles] = useState(() => {
    return localStorageService.getAllRoles();
  });

  // Check if user has valid token on app start
  useEffect(() => {
    const token = localStorageService.getAuthToken();
    const refreshToken = localStorageService.getRefreshToken();

    // Check if user has valid token on app start
    if (token && refreshToken && !user) {
      // Try to refresh token to validate user session
      refreshAuthToken();
    }
  }, [user]);

  const logout = () => {
    authService.clearAuthData();
    setUser(null);
    setSelectedRole(null);
    setRoles([]);
  };

  const switchRole = (newRole) => {
    authService.storeSelectedRole(newRole);
    // Full page reload to reset all state and pick up new role from localStorage
    window.location.reload();
  };

  const refreshAuthToken = async () => {
    try {
      const refreshToken = authService.getRefreshToken();
      if (!refreshToken) {
        logout();
        return false;
      }

      const result = await authService.refreshToken(refreshToken);

      if (result.success && result.data?.access) {
        localStorageService.setAuthToken(result.data.access);
        return true;
      } else {
        logout();
        return false;
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      logout();
      return false;
    }
  };

  return (
    <AuthContext.Provider value={{
      // State
      user,
      setUser,
      roles,
      setRoles,
      selectedRole,
      setSelectedRole,
      loading,
      setLoading,
      // Functions
      logout,
      switchRole,
      refreshAuthToken
    }}>
      {children}
    </AuthContext.Provider>
  );
}
